export default __webpack_public_path__ + "static/media/Validataion.0a33a79d.svg";